document.addEventListener('DOMContentLoaded', function() {
    // Utiliser la fonction log commune
    function logAction(message, data) {
        window.StoreFinder.logAction('HEADER', message, data);
    }

    // Fonction pour masquer le champ de recherche lors de l'initialisation
    function hideSearchFieldOnLoad() {
        setTimeout(function() {
            const userLocation = localStorage.getItem('userLocation');
            const selectedShop = localStorage.getItem('selectedShop');
            
            if (userLocation && userLocation !== 'Aucune') {
                // Si nous avons une ville, masquer le champ
                $('#header-dealer-search-container .search-input-group').hide();
                logAction("Champ de recherche masqué au chargement car ville existante: " + userLocation);
            } else if (selectedShop) {
                // Si nous avons un magasin mais pas de ville, afficher le champ
                $('#header-dealer-search-container .search-input-group').show();
                logAction("Champ de recherche affiché au chargement - magasin sans ville");
            } else {
                // Aucune sélection, afficher le champ
                $('#header-dealer-search-container .search-input-group').show();
                logAction("Champ de recherche affiché au chargement - aucune sélection");
            }
        }, 300);
    }

    // Fonction centralisée pour gérer la visibilité du champ de recherche header
    function toggleHeaderSearchField(show) {
        window.StoreFinder.toggleSearchField('#header-dealer-search-container .search-input-group', show, 'HEADER');
    }

    // Utiliser le chargement centralisé des librairies
    window.StoreFinder.loadLibraries(function() {
        initHeaderDealerSearch();
    });
    
    function initHeaderDealerSearch() {
        // Utiliser les warehouses du core commun
        let warehouses = window.StoreFinder.warehouses;
        let userLocation = window.StoreFinder.userLocation;
        
        // Variables pour contrôler les tentatives de recherche d'éléments
        let isDrawerOpen = false;
        let autocompleteAttempts = 0;
        let buttonEventsAttempts = 0;
        let chooseButtonsAttempts = 0;
        const MAX_ATTEMPTS = 5;
        
        // Exposer les fonctions au niveau global pour permettre la synchronisation entre drawers
        window.updateHeaderStoreInterface = function(shopName) {
            updateHeaderStoreList(shopName);
        };
        
        // Si les fonctions du drawer produit ne sont pas encore disponibles, les créer
        if (!window.updateStoreInterface) {
            window.updateStoreInterface = function(shopName) {
                logAction("updateStoreInterface appelée depuis header pour: " + shopName);
                updateHeaderStoreList(shopName);
                
                const savedShop = window.StoreFinder.getSelectedShop();
                if (savedShop) {
                    displayHeaderSelectedShop(savedShop, true);
                }
            };
        }
        
        // Observer l'ouverture du drawer header
        function setupHeaderDrawerObserver() {
            const headerDrawers = document.querySelectorAll('header-store-finder-drawer');
            if (headerDrawers.length > 0) {
                const observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        if (mutation.attributeName === 'hidden') {
                            const isHidden = mutation.target.hidden;
                            isDrawerOpen = !isHidden;
                            
                            if (isDrawerOpen) {
                                autocompleteAttempts = 0;
                                buttonEventsAttempts = 0;
                                chooseButtonsAttempts = 0;
                                
                                setTimeout(function() {
                                    logAction("Header drawer ouvert, initialisation des composants");
                                    
                                    // Restaurer d'abord les coordonnées depuis le cache
                                    restoreHeaderUserLocationCoordinates();
                                    
                                    // Mettre à jour l'affichage de la localisation
                                    updateHeaderLocationDisplay();
                                    
                                    // Masquer/afficher le champ de recherche selon le contexte
                                    hideSearchFieldOnLoad();
                                    
                                    // Initialiser les composants
                                    initHeaderAutocomplete();
                                    initHeaderButtonEvents();
                                    initHeaderChooseDefaultButtons();
                                    
                                    // Le magasin sera restauré par updateHeaderStoreList si nécessaire
                                    
                                    // Mettre à jour la liste avec le bon favori
                                    const favoriteShopName = getSelectedShopName();
                                    updateHeaderStoreList(favoriteShopName);
                                }, 500);
                            }
                        }
                    });
                });
                
                headerDrawers.forEach(drawer => {
                    observer.observe(drawer, { attributes: true });
                });
                
                isDrawerOpen = !headerDrawers[0].hidden;
                if (isDrawerOpen) {
                    setTimeout(function() {
                        logAction("Header drawer déjà ouvert au chargement");
                        
                        // Restaurer d'abord les coordonnées depuis le cache
                        restoreHeaderUserLocationCoordinates();
                        
                        // Mettre à jour l'affichage de la localisation
                        updateHeaderLocationDisplay();
                        
                        // Masquer/afficher le champ de recherche selon le contexte
                        hideSearchFieldOnLoad();
                        
                        // Initialiser les composants
                        initHeaderAutocomplete();
                        initHeaderButtonEvents();
                        initHeaderChooseDefaultButtons();
                        
                        // Le magasin sera restauré par updateHeaderStoreList si nécessaire
                        
                        // Mettre à jour la liste avec le bon favori
                        const favoriteShopName = getSelectedShopName();
                        updateHeaderStoreList(favoriteShopName);
                    }, 500);
                }
            }
        }
        
        // Charger les données des boutiques via le core commun
        window.StoreFinder.loadWarehouses(function(data) {
            warehouses = data;
            
            // Restaurer les coordonnées utilisateur pour recalculer les distances
            restoreHeaderUserLocationCoordinates();
            
            // Générer la liste des magasins dynamiquement
            generateHeaderStoreList(warehouses);
            
            loadSavedShop();
            hideSearchFieldOnLoad();
            setupHeaderDrawerObserver();
        });
        
        // Utiliser les fonctions communes du core
        function calculateDistance(lat1, lon1, lat2, lon2) {
            return window.StoreFinder.calculateDistance(lat1, lon1, lat2, lon2);
        }
        
        function formatDistance(distance) {
            return window.StoreFinder.formatDistance(distance);
        }
        
        function findNearestShops(lat, lng) {
            return window.StoreFinder.findNearestShops(lat, lng, warehouses);
        }
        
        function saveShopsList(shops) {
            window.StoreFinder.saveShopsList(shops);
        }
        
        // Utiliser la fonction commune pour sauvegarder
        function saveSelectedShop(shop, keepSearchVisible = false) {
            const shopData = window.StoreFinder.saveSelectedShop(shop, keepSearchVisible);
            
            // Mettre à jour l'affichage spécifique au header
            updateHeaderStoreList(shop.name);
            displayHeaderSelectedShop(shopData, keepSearchVisible);
        }

        // Fonction pour initialiser les écouteurs des boutons "Choisir par défaut" du header
        function initHeaderChooseDefaultButtons() {
            if (!isDrawerOpen) return;
            
            if (chooseButtonsAttempts >= MAX_ATTEMPTS) {
                return;
            }
            chooseButtonsAttempts++;
            
            const chooseButtons = document.querySelectorAll('#HeaderStoreFinderDrawer .header-store-choose-btn');
            if (chooseButtons.length === 0) {
                if (chooseButtonsAttempts < MAX_ATTEMPTS) {
                    setTimeout(initHeaderChooseDefaultButtons, 500);
                }
                return;
            }
            
            logAction(`Initialisation des écouteurs header pour ${chooseButtons.length} boutons "Choisir par défaut"`);
            
            chooseButtons.forEach(button => {
                // Prévenir les multiples écouteurs
                if (!button.hasAttribute('data-header-choose-events-initialized')) {
                    button.setAttribute('data-header-choose-events-initialized', 'true');
                    
                    button.addEventListener('click', function(e) {
                        e.preventDefault();
                        const storeName = this.getAttribute('data-store-name');
                        logAction(`Clic sur le bouton header "Choisir par défaut" pour ${storeName}`);
                        
                        const shop = warehouses.find(w => w.name === storeName);
                        
                        if (shop) {
                            saveSelectedShop(shop, true);
                            
                            document.querySelectorAll('#HeaderStoreFinderDrawer .header-store-list__item').forEach(item => {
                                const itemName = item.getAttribute('data-store-name');
                                const isSelected = itemName === storeName;
                                
                                if (isSelected) {
                                    item.classList.add('favorite-store');
                                } else {
                                    item.classList.remove('favorite-store');
                                }
                            });
                        } else {
                            logAction(`Magasin ${storeName} non trouvé dans la liste des magasins disponibles`);
                        }
                    });
                }
            });
        }
        
        // Fonction pour restaurer les coordonnées utilisateur depuis le localStorage
        function restoreHeaderUserLocationCoordinates() {
            const userLocationValue = localStorage.getItem('userLocation');
            const nearestShopsJson = localStorage.getItem('nearestShops');
            
            // Si nous avons une localisation utilisateur et des magasins en cache
            if (userLocationValue && userLocationValue !== 'Aucune' && nearestShopsJson) {
                try {
                    const cachedShops = JSON.parse(nearestShopsJson);
                    if (cachedShops.length > 0) {
                        // Recréer la variable userLocation pour les calculs futurs
                        // On peut essayer de la récupérer depuis les coordonnées sauvegardées
                        logAction("Coordonnées utilisateur header restaurées depuis le cache pour: " + userLocationValue);
                        
                        // Mettre à jour les distances dans les magasins si possible
                        cachedShops.forEach(cachedShop => {
                            const shop = warehouses.find(w => w.id_interne === cachedShop.id_interne);
                            if (shop && cachedShop.km) {
                                // Reconstituer l'objet distance depuis km
                                const match = String(cachedShop.km).match(/([\d\.]+)\s*(km|m)/);
                                if (match) {
                                    let distance = parseFloat(match[1]);
                                    if (match[2] === 'm') {
                                        distance /= 1000;
                                    }
                                    shop.distance = distance;
                                }
                            }
                        });
                        
                        logAction("Distances header restaurées depuis le cache");
                    }
                } catch (e) {
                    logAction("Erreur lors de la restauration des coordonnées header:", e);
                }
            }
        }
        
        // Mettre à jour la liste des magasins dans le header drawer
        function updateHeaderStoreList(favoriteShopName) {
            const headerStoreItems = document.querySelectorAll('#HeaderStoreFinderDrawer .header-store-list__item');
            if (headerStoreItems.length === 0) {
                logAction("updateHeaderStoreList: Aucun item de magasin header trouvé.");
                return;
            }

            const parentList = headerStoreItems[0].parentNode;
            const storesArray = Array.from(headerStoreItems);

            const nearestShopsJson = localStorage.getItem('nearestShops');
            let nearestShopsData = [];
            if (nearestShopsJson) {
                try {
                    nearestShopsData = JSON.parse(nearestShopsJson);
                } catch (e) {
                    console.error("Erreur lors du parsing de nearestShops depuis localStorage:", e);
                }
            }
            
            const userLocationValue = localStorage.getItem('userLocation');
            const hasUserLocation = userLocationValue && userLocationValue !== 'Aucune';

            const enrichedStores = storesArray.map(storeElement => {
                const nameElement = storeElement.querySelector('h3');
                const storeName = nameElement ? nameElement.firstChild.textContent.trim() : '';

                let distanceSpan = nameElement ? nameElement.querySelector('.header-store-distance') : null;

                const shopData = nearestShopsData.find(s => s.name && s.name.trim() === storeName);
                let displayDistance = "";
                let distanceKm = Infinity; // Pour le tri, ceux sans distance sont mis à la fin

                // N'afficher la distance que si nous avons une localisation utilisateur
                if (hasUserLocation && shopData && shopData.km) {
                    displayDistance = `(${shopData.km})`;
                    const match = String(shopData.km).match(/([\d\.]+)\s*(km|m)/);
                    if (match) {
                        distanceKm = parseFloat(match[1]);
                        if (match[2] === 'm') {
                            distanceKm /= 1000;
                        }
                    }
                }

                if (distanceSpan) {
                    distanceSpan.textContent = displayDistance;
                }
                
                return {
                    element: storeElement,
                    name: storeName,
                    distanceKm: distanceKm,
                    isFavorite: storeName === favoriteShopName
                };
            });

            // Tri des magasins: favoris d'abord, puis par distance, puis par nom
            enrichedStores.sort((a, b) => {
                // Si un magasin est favori, il vient en premier
                if (a.isFavorite && !b.isFavorite) return -1;
                if (!a.isFavorite && b.isFavorite) return 1;

                // Si aucun magasin n'est favori ou les deux sont favoris, trier par distance
                if (hasUserLocation && a.distanceKm !== b.distanceKm) {
                    return a.distanceKm - b.distanceKm;
                }
                
                // Fallback: trier par nom si pas de distance ou distances égales
                return a.name.localeCompare(b.name);
            });

            // Vider la liste actuelle dans le DOM avant de la reconstruire
            while (parentList.firstChild) {
                parentList.removeChild(parentList.firstChild);
            }
            
            // Réinsérer les éléments triés dans le DOM
            enrichedStores.forEach(storeData => {
                parentList.appendChild(storeData.element);
                if (storeData.isFavorite) {
                    storeData.element.classList.add('favorite-store');
                } else {
                    storeData.element.classList.remove('favorite-store');
                }
            });
            
            logAction("Liste des magasins header mise à jour avec tri physique.", { 
                favorite: favoriteShopName || "Aucun", 
                hasLocation: hasUserLocation,
                count: enrichedStores.length 
            });
        }
        
        // Charger la boutique sauvegardée
        function loadSavedShop() {
            const shopData = window.StoreFinder.getSelectedShop();
            if (shopData) {
                updateHeaderLocationDisplay();
                displayHeaderSelectedShop(shopData, true);
                updateHeaderStoreList(shopData.name);
                logAction("Magasin header restauré depuis localStorage: " + shopData.name);
            } else {
                updateHeaderLocationDisplay();
            }
        }
        
        // Afficher la boutique sélectionnée dans le header
        function displayHeaderSelectedShop(shopData, keepSearchVisible = false) {
            const userLocationValue = localStorage.getItem('userLocation');
            const hasUserLocation = userLocationValue && userLocationValue !== 'Aucune';
            
            const userLocationDisplay = document.getElementById('header-user-location-display');
            if (userLocationDisplay) {
                if (!userLocationValue || userLocationValue === 'Paris (75005)' || userLocationValue === 'Paris 05 (75005)') {
                    localStorage.setItem('userLocation', 'Aucune');
                    userLocationDisplay.textContent = 'Aucune';
                } else {
                    userLocationDisplay.textContent = userLocationValue;
                }
            }
            
            const shopNameElement = document.getElementById('header-dealer-shop-name');
            const shopAddressElement = document.getElementById('header-dealer-shop-address');
            const selectedShopContainer = document.getElementById('header-dealer-selected-shop-container');
            
            if (shopNameElement && shopAddressElement && selectedShopContainer) {
                let displayName = shopData.name;
                if (hasUserLocation && shopData.km && shopData.km !== 'Choix par défaut') {
                    displayName += ` (${shopData.km})`;
                } else if (!hasUserLocation) {
                    displayName += ` (Choix par défaut)`;
                }
                
                shopNameElement.textContent = displayName;
                shopAddressElement.textContent = "Magasin sélectionné";
                selectedShopContainer.style.display = 'block';
                
                if (!keepSearchVisible) {
                    const searchContainer = document.getElementById('header-dealer-search-container');
                    if (searchContainer) {
                        searchContainer.querySelector('.search-input-group').style.display = 'none';
                    }
                }
            }
            
            logAction(`Boutique header affichée: ${shopData.name}`);
        }
        
        // Fonction pour obtenir le nom du magasin sélectionné
        function getSelectedShopName() {
            const shopData = window.StoreFinder.getSelectedShop();
            return shopData ? shopData.name : null;
        }
        
        // Fonction pour mettre à jour l'affichage de la localisation header
        function updateHeaderLocationDisplay() {
            const userLocation = localStorage.getItem('userLocation');
            const standaloneDisplay = document.getElementById('header-user-location-display-standalone');
            const inShopDisplay = document.getElementById('header-user-location-display');
            const locationContainer = document.getElementById('header-user-location-container');
            
            if (userLocation && userLocation !== 'Aucune') {
                if (standaloneDisplay) {
                    standaloneDisplay.textContent = userLocation;
                }
                if (locationContainer) {
                    locationContainer.style.display = 'flex';
                }
                if (inShopDisplay) {
                    inShopDisplay.textContent = userLocation;
                }
            } else {
                if (locationContainer) {
                    locationContainer.style.display = 'none';
                }
            }
        }
        
        // Charger l'API Google Places si pas déjà chargée
        function loadGooglePlacesAPI() {
            return new Promise((resolve, reject) => {
                if (typeof google !== 'undefined' && google.maps && google.maps.places) {
                    resolve();
                    return;
                }
                
                if (document.querySelector('script[src*="maps.googleapis.com"]')) {
                    // L'API est en cours de chargement, attendre qu'elle soit prête
                    const checkGoogle = setInterval(() => {
                        if (typeof google !== 'undefined' && google.maps && google.maps.places) {
                            clearInterval(checkGoogle);
                            resolve();
                        }
                    }, 100);
                    return;
                }
                
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA7JBoMVZuoP1Qpta_RoZfWRgl5XjtQSBI&libraries=places&language=fr&region=FR`;
                script.async = true;
                script.defer = true;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        }

        // Fonction pour initialiser l'autocomplétion header avec Google Places
        function initHeaderAutocomplete() {
            if (!isDrawerOpen) return;
            
            if (autocompleteAttempts >= MAX_ATTEMPTS) {
                return;
            }
            autocompleteAttempts++;
            
            const searchInput = document.getElementById('header-dealer-city-search');
            if (!searchInput) {
                if (autocompleteAttempts < MAX_ATTEMPTS) {
                    setTimeout(initHeaderAutocomplete, 500);
                }
                return;
            }
            
            // Vérifier si l'autocomplétion n'est pas déjà initialisée
            if (searchInput.hasAttribute('data-google-autocomplete-initialized')) {
                return;
            }
            
            logAction("Initialisation de l'autocomplétion header avec Google Places");
            
            loadGooglePlacesAPI().then(() => {
                try {
                    // Créer l'instance d'autocomplétion Google Places (élargi pour codes postaux et arrondissements)
                    const autocomplete = new google.maps.places.Autocomplete(searchInput, {
                        types: ['geocode'], // Permet villes, codes postaux, arrondissements, quartiers
                        componentRestrictions: { country: 'FR' },
                        fields: ['place_id', 'name', 'geometry', 'address_components', 'formatted_address']
                    });
                    
                    // Marquer comme initialisé
                    searchInput.setAttribute('data-google-autocomplete-initialized', 'true');
                    
                    // Écouter la sélection d'un lieu
                    autocomplete.addListener('place_changed', function() {
                        const place = autocomplete.getPlace();
                        
                        if (!place.geometry || !place.geometry.location) {
                            console.error("Lieu sélectionné sans coordonnées:", place);
                            return;
                        }
                        
                        const cityLat = place.geometry.location.lat();
                        const cityLng = place.geometry.location.lng();
                        
                        // Extraire la ville, arrondissement et code postal depuis address_components
                        let cityName = '';
                        let sublocality = ''; // arrondissement ou quartier
                        let postalCode = '';
                        let adminLevel = ''; // département, région
                        
                        if (place.address_components) {
                            place.address_components.forEach(component => {
                                // Ville principale
                                if (component.types.includes('locality')) {
                                    cityName = component.long_name;
                                }
                                // Arrondissement ou quartier (ex: 17ème Arrondissement)
                                if (component.types.includes('sublocality_level_1') || component.types.includes('sublocality')) {
                                    sublocality = component.long_name;
                                }
                                // Code postal
                                if (component.types.includes('postal_code')) {
                                    postalCode = component.long_name;
                                }
                                // Niveau administratif (fallback pour certaines zones)
                                if (component.types.includes('administrative_area_level_2')) {
                                    if (!cityName) adminLevel = component.long_name;
                                }
                            });
                        }
                        
                        // Construire le nom de localisation de façon intelligente
                        let finalLocationName = '';
                        
                        // Cas 1: Arrondissement précis (ex: "17ème Arrondissement, Paris")
                        if (sublocality && cityName) {
                            // Simplifier les noms d'arrondissements parisiens
                            if (sublocality.includes('Arrondissement') && cityName.toLowerCase() === 'paris') {
                                const arrondNumber = sublocality.match(/(\d+)/);
                                if (arrondNumber) {
                                    finalLocationName = `Paris ${arrondNumber[1]}`;
                                } else {
                                    finalLocationName = `${cityName} ${sublocality}`;
                                }
                            } else {
                                finalLocationName = `${sublocality}, ${cityName}`;
                            }
                        }
                        // Cas 2: Ville simple
                        else if (cityName) {
                            finalLocationName = cityName;
                        }
                        // Cas 3: Seulement arrondissement/quartier
                        else if (sublocality) {
                            finalLocationName = sublocality;
                        }
                        // Cas 4: Fallback administratif
                        else if (adminLevel) {
                            finalLocationName = adminLevel;
                        }
                        // Cas 5: Utiliser le nom du lieu Google
                        else {
                            finalLocationName = place.name || place.formatted_address?.split(',')[0] || 'Lieu sélectionné';
                        }
                        
                        // Calculer les distances pour toutes les boutiques
                        const nearestShops = findNearestShops(cityLat, cityLng);
                        
                        // Sauvegarder la localisation sélectionnée avec format intelligent
                        const locationText = postalCode ? `${finalLocationName} (${postalCode})` : finalLocationName;
                        localStorage.setItem('userLocation', locationText);
                        
                        logAction(`Ville sélectionnée depuis header: ${locationText}`);
                        
                        // Mettre à jour l'affichage de la localisation
                        updateHeaderLocationDisplay();
                        
                        // Sauvegarder la liste pour trier les magasins
                        saveShopsList(nearestShops);
                        
                        // Mettre à jour les distances dans le drawer header
                        const favoriteShopName = getSelectedShopName();
                        updateHeaderStoreList(favoriteShopName);
                        
                        // Masquer le champ de recherche puisqu'une ville a été sélectionnée
                        toggleHeaderSearchField(false);
                        
                        // Mettre à jour le magasin sélectionné s'il y en a un
                        let shopJson = localStorage.getItem('selectedShop');
                        if (shopJson) {
                            try {
                                const savedShop = JSON.parse(shopJson);
                                const shop = warehouses.find(w => w.id_interne === savedShop.id_interne);
                                if (shop) {
                                    // Mettre à jour la distance
                                    shop.distance = calculateDistance(
                                        cityLat,
                                        cityLng,
                                        shop.address.coor_1,
                                        shop.address.coor_2
                                    );
                                    // Mettre à jour l'affichage
                                    const updatedShopData = {
                                        name: shop.name,
                                        id_interne: shop.id_interne,
                                        km: formatDistance(shop.distance)
                                    };
                                    localStorage.setItem('selectedShop', JSON.stringify(updatedShopData));
                                    displayHeaderSelectedShop(updatedShopData, true);
                                }
                            } catch (e) {
                                console.error("Erreur lors de la mise à jour du magasin header sélectionné:", e);
                            }
                        }
                        
                        // Vider le champ de recherche après sélection
                        setTimeout(() => {
                            searchInput.value = '';
                        }, 100);
                    });
                    
                    logAction("Autocomplétion header initialisée avec succès avec Google Places API");
                } catch (error) {
                    logAction("Erreur lors de l'initialisation de l'autocomplétion header:", error.message);
                    if (autocompleteAttempts < MAX_ATTEMPTS) {
                        setTimeout(initHeaderAutocomplete, 1000);
                    }
                }
            }).catch(error => {
                logAction("Erreur lors du chargement de Google Places API:", error.message);
                if (autocompleteAttempts < MAX_ATTEMPTS) {
                    setTimeout(initHeaderAutocomplete, 1000);
                }
            });
        }
        
        // Fonction pour initialiser les événements des boutons header
        function initHeaderButtonEvents() {
            if (!isDrawerOpen) return;
            
            if (buttonEventsAttempts >= MAX_ATTEMPTS) {
                return;
            }
            buttonEventsAttempts++;
            
            const gpsBtn = document.getElementById('header-dealer-gps-btn');
            const clearLocationBtn = document.getElementById('header-clear-location-btn');
            const removeShopBtn = document.getElementById('header-dealer-remove-shop');
            
            if (!gpsBtn) {
                if (buttonEventsAttempts < MAX_ATTEMPTS) {
                    setTimeout(initHeaderButtonEvents, 500);
                }
                return;
            }
            
            logAction("Initialisation des événements des boutons header");
            
            // Prévenir les multiples écouteurs en vérifiant un attribut data
            if (!gpsBtn.hasAttribute('data-header-events-initialized')) {
                gpsBtn.setAttribute('data-header-events-initialized', 'true');
                
                // Bouton GPS
                gpsBtn.addEventListener('click', function() {
                    logAction("Clic sur le bouton GPS header");
                    
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(function(position) {
                            const lat = position.coords.latitude;
                            const lng = position.coords.longitude;
                            
                            // Utiliser Google Geocoding API pour trouver l'adresse
                            loadGooglePlacesAPI().then(() => {
                                const geocoder = new google.maps.Geocoder();
                                const latlng = new google.maps.LatLng(lat, lng);
                                
                                geocoder.geocode({ location: latlng }, function(results, status) {
                                    if (status === 'OK' && results && results.length > 0) {
                                        // Chercher le résultat avec une ville et un code postal
                                        let bestResult = null;
                                        let cityName = '';
                                        let postalCode = '';
                                        
                                        for (let result of results) {
                                            let tempCity = '';
                                            let tempPostal = '';
                                            
                                            if (result.address_components) {
                                                result.address_components.forEach(component => {
                                                    if (component.types.includes('locality')) {
                                                        tempCity = component.long_name;
                                                    }
                                                    if (component.types.includes('postal_code')) {
                                                        tempPostal = component.long_name;
                                                    }
                                                });
                                            }
                                            
                                            if (tempCity && tempPostal) {
                                                cityName = tempCity;
                                                postalCode = tempPostal;
                                                bestResult = result;
                                                break;
                                            } else if (tempCity && !cityName) {
                                                cityName = tempCity;
                                                bestResult = result;
                                            }
                                        }
                                        
                                        if (cityName) {
                                            const locationText = postalCode ? `${cityName} (${postalCode})` : cityName;
                                            
                                            localStorage.setItem('userLocation', locationText);
                                            updateHeaderLocationDisplay();
                                            
                                            // Calculer les distances pour toutes les boutiques
                                            const nearestShops = findNearestShops(lat, lng);
                                            saveShopsList(nearestShops);
                                            
                                            const favoriteShopName = getSelectedShopName();
                                            updateHeaderStoreList(favoriteShopName);
                                            
                                            toggleHeaderSearchField(false);
                                            
                                            // Mettre à jour le magasin sélectionné s'il y en a un
                                            let shopJson = localStorage.getItem('selectedShop');
                                            if (shopJson) {
                                                try {
                                                    const savedShop = JSON.parse(shopJson);
                                                    const shop = warehouses.find(w => w.id_interne === savedShop.id_interne);
                                                    if (shop) {
                                                        shop.distance = calculateDistance(lat, lng, shop.address.coor_1, shop.address.coor_2);
                                                        const updatedShopData = {
                                                            name: shop.name,
                                                            id_interne: shop.id_interne,
                                                            km: formatDistance(shop.distance)
                                                        };
                                                        localStorage.setItem('selectedShop', JSON.stringify(updatedShopData));
                                                        displayHeaderSelectedShop(updatedShopData, true);
                                                    }
                                                } catch (e) {
                                                    console.error("Erreur lors de la mise à jour du magasin header sélectionné:", e);
                                                }
                                            }
                                            
                                            logAction("Position GPS obtenue et ville trouvée avec Google Geocoding: " + locationText);
                                        } else {
                                            // Fallback : utiliser les coordonnées directement
                                            localStorage.setItem('userLocation', 'Position actuelle');
                                            updateHeaderLocationDisplay();
                                            
                                            const nearestShops = findNearestShops(lat, lng);
                                            saveShopsList(nearestShops);
                                            
                                            const favoriteShopName = getSelectedShopName();
                                            updateHeaderStoreList(favoriteShopName);
                                            
                                            toggleHeaderSearchField(false);
                                            
                                            logAction("Position GPS obtenue avec coordonnées en fallback");
                                        }
                                    } else {
                                        console.error("Erreur lors du géocodage inverse:", status);
                                        
                                        // Fallback : utiliser les coordonnées directement
                                        localStorage.setItem('userLocation', 'Position actuelle');
                                        updateHeaderLocationDisplay();
                                        
                                        const nearestShops = findNearestShops(lat, lng);
                                        saveShopsList(nearestShops);
                                        
                                        const favoriteShopName = getSelectedShopName();
                                        updateHeaderStoreList(favoriteShopName);
                                        
                                        toggleHeaderSearchField(false);
                                        
                                        logAction("Position GPS obtenue avec fallback après erreur géocodage");
                                    }
                                });
                            }).catch(error => {
                                console.error("Erreur lors du chargement de Google API pour GPS:", error);
                                
                                // Fallback : utiliser les coordonnées directement
                                localStorage.setItem('userLocation', 'Position actuelle');
                                updateHeaderLocationDisplay();
                                
                                const nearestShops = findNearestShops(lat, lng);
                                saveShopsList(nearestShops);
                                
                                const favoriteShopName = getSelectedShopName();
                                updateHeaderStoreList(favoriteShopName);
                                
                                toggleHeaderSearchField(false);
                                
                                logAction("Position GPS obtenue avec fallback après erreur API");
                            });
                        }, function(error) {
                            logAction("Erreur de géolocalisation: " + error.message);
                        });
                    }
                });
            }
            
            // Bouton de suppression de localisation
            if (clearLocationBtn && !clearLocationBtn.hasAttribute('data-header-events-initialized')) {
                clearLocationBtn.setAttribute('data-header-events-initialized', 'true');
                
                clearLocationBtn.addEventListener('click', function() {
                    localStorage.setItem('userLocation', 'Aucune');
                    updateHeaderLocationDisplay();
                    
                    document.querySelectorAll('#HeaderStoreFinderDrawer .header-store-distance').forEach(span => {
                        span.textContent = '';
                    });
                    
                    // Afficher le champ de recherche après suppression de localisation
                    toggleHeaderSearchField(true);
                    
                    // Synchroniser avec le drawer produit
                    if (typeof window.updateLocationDisplay === 'function') {
                        window.updateLocationDisplay();
                    }
                    
                    // Mettre à jour les deux drawers
                    const favoriteShopName = getSelectedShopName();
                    updateHeaderStoreList(favoriteShopName);
                    if (typeof window.updateShopifyAvailability === 'function') {
                        window.updateShopifyAvailability(favoriteShopName);
                    }
                    
                    logAction("Localisation header supprimée et champ de recherche réaffiché");
                });
            }
            
            // Bouton de suppression de magasin
            if (removeShopBtn && !removeShopBtn.hasAttribute('data-header-events-initialized')) {
                removeShopBtn.setAttribute('data-header-events-initialized', 'true');
                
                removeShopBtn.addEventListener('click', function() {
                    localStorage.removeItem('selectedShop');
                    
                    const selectedShopContainer = document.getElementById('header-dealer-selected-shop-container');
                    if (selectedShopContainer) {
                        selectedShopContainer.style.display = 'none';
                    }
                    
                    // Mettre à jour le texte du bouton "Trouver mon magasin"
                    if (typeof window.updateStoreFinderButtonText === 'function') {
                        window.updateStoreFinderButtonText();
                    }
                    
                    // Afficher le champ de recherche après suppression de magasin
                    toggleHeaderSearchField(true);
                    
                    document.querySelectorAll('#HeaderStoreFinderDrawer .header-store-list__item').forEach(item => {
                        item.classList.remove('favorite-store');
                    });
                    
                    // Synchroniser avec le drawer produit
                    if (typeof window.updateShopifyAvailability === 'function') {
                        window.updateShopifyAvailability(null);
                    }
                    
                    logAction("Magasin header supprimé et champ de recherche réaffiché");
                });
            }
        }

        // Fonction pour générer l'URL de la page du magasin
        function generateStoreUrl(store) {
            if (!store.address || !store.address.city || !store.address.zip) {
                return '#';
            }
            
            // Nettoyer le nom de la ville
            let cityName = store.address.city.toLowerCase();
            // Supprimer les caractères spéciaux et remplacer les espaces par des tirets
            cityName = cityName
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '') // Supprimer les accents
                .replace(/'/g, '-') // Remplacer les apostrophes par des tirets
                .replace(/[^a-z0-9\s-]/g, '') // Garder seulement lettres, chiffres, espaces et tirets
                .replace(/\s+/g, '-') // Remplacer espaces par tirets
                .replace(/-+/g, '-') // Supprimer tirets multiples
                .replace(/^-|-$/g, ''); // Supprimer tirets en début/fin
            
            const zipCode = store.address.zip;
            
            return `/pages/boutique-stokomani-${cityName}-${zipCode}`;
        }

        // Générer la liste des magasins HTML dynamiquement
        function generateHeaderStoreList(storesData) {
            const storeListContainer = document.getElementById('header-dynamic-store-list');
            if (!storeListContainer || !storesData || storesData.length === 0) {
                logAction("generateHeaderStoreList: Container ou données non disponibles");
                return;
            }
            
            // Vider le container
            storeListContainer.innerHTML = '';
            
            // Générer un élément pour chaque magasin
            storesData.forEach(store => {
                const listItem = document.createElement('li');
                listItem.className = 'header-store-list__item';
                listItem.setAttribute('data-store-name', store.name);
                
                const address = store.address;
                const addressHtml = `${address.address1 || ''}<br>${address.zip || ''} ${address.city || ''}<br>`;
                
                // Générer l'URL de la page du magasin
                const storeUrl = generateStoreUrl(store);
                
                listItem.innerHTML = `
                    <div style="margin-left: 30px;">
                        <h3 class="h5" style="margin-bottom: 10px; font-weight: bold;">
                            ${store.name}
                            <span class="header-store-distance text-sm text-subtext" style="font-weight: normal; margin-left: 5px;"></span>
                        </h3>
                        
                        <div class="store-address">
                            ${addressHtml}
                        </div>
                        
                        <div class="button-group">
                            <a href="${storeUrl}" class="store-link-btn" style="background-color: rgb(0, 152, 62);">Voir la page du magasin</a>
                            <a href="#" class="store-link-btn header-store-choose-btn" data-store-name="${store.name}">Choisir par défaut</a>
                        </div>
                    </div>
                `;
                
                storeListContainer.appendChild(listItem);
            });
            
            // Réinitialiser les écouteurs de boutons après génération
            setTimeout(() => {
                initHeaderChooseDefaultButtons();
                
                // Forcer une réinitialisation de l'autocomplétion maintenant que les données sont chargées
                autocompleteAttempts = 0;
                if (isDrawerOpen) {
                    initHeaderAutocomplete();
                }
            }, 100);
            
            logAction(`Liste header générée avec ${storesData.length} magasins depuis le webservice`);
        }
    }
    
    // Écouter les changements dans localStorage pour synchronisation temps réel avec le drawer produit
    window.addEventListener('storage', function(e) {
        if (e.key === 'selectedShop' || e.key === 'userLocation') {
            // Petite temporisation pour éviter les conflits avec l'autre drawer
            setTimeout(function() {
                logAction("Événement storage détecté dans header: " + e.key);
                
                // Recharger les données et synchroniser
                const savedShopJson = localStorage.getItem('selectedShop');
                if (savedShopJson) {
                    try {
                        const savedShop = JSON.parse(savedShopJson);
                        
                        // Mettre à jour l'affichage du magasin sélectionné avec keepSearchVisible=true
                        // pour maintenir la cohérence avec le comportement du drawer produit
                        displayHeaderSelectedShop(savedShop, true);
                        
                        // Mettre à jour la liste des magasins
                        updateHeaderStoreList(savedShop.name);
                        
                        logAction("Header synchronisé via storage: " + savedShop.name);
                    } catch (err) {
                        logAction("Erreur lors de la synchronisation storage header:", err);
                    }
                } else {
                    // Magasin supprimé
                    const selectedShopContainer = document.getElementById('header-dealer-selected-shop-container');
                    if (selectedShopContainer) {
                        selectedShopContainer.style.display = 'none';
                    }
                    
                    // Réafficher le champ de recherche
                    toggleHeaderSearchField(true);
                    
                    // Mettre à jour la liste (supprimer la classe favorite-store)
                    updateHeaderStoreList(null);
                    
                    logAction("Header synchronisé: magasin supprimé via storage");
                }
                
                // Mettre à jour l'affichage de la localisation
                updateHeaderLocationDisplay();
                
                // Mettre à jour le texte du bouton "Trouver mon magasin"
                if (typeof window.updateStoreFinderButtonText === 'function') {
                    window.updateStoreFinderButtonText();
                }
            }, 150); // Légèrement plus long que le drawer produit pour éviter les conflits
        }
    });
}); 